import React, { useState } from 'react';
import { useTranslation } from '../../i18n';
import { SECTIONS } from './sections';
import SettingsSidebar from './SettingsSidebar';
import ProfileSection from './sections/ProfileSection';
import LanguageSection from './sections/LanguageSection';
import EventsSection from './sections/EventsSection';
import { useUserSettings } from './hooks/useUserSettings';
import shared from './Settings.shared.module.css';
import styles from './SettingsPage.module.css';

const SECTION_COMPONENTS = {
    [SECTIONS.PROFILE]:  ProfileSection,
    [SECTIONS.LANGUAGE]: LanguageSection,
    [SECTIONS.EVENTS]:   EventsSection
};

function SettingsPage() {
    const { t } = useTranslation('shell');
    const [activeSection, setActiveSection] = useState(SECTIONS.PROFILE);
    const [alertsExpanded, setAlertsExpanded] = useState(true);

    const { settings, loading, error, editUser } = useUserSettings();

    const ActiveSection = SECTION_COMPONENTS[activeSection];

    const renderContent = () => {
        if (loading || !settings) {
            return <p className={shared.placeholder}>{t('settings.loading')}</p>;
        }
        if (error) {
            return <p className={shared.placeholder}>{error}</p>;
        }
        return ActiveSection
            ? <ActiveSection settings={settings} editUser={editUser} />
            : null;
    };

    return (
        <div className={styles.settingsPage}>
            <SettingsSidebar
                activeSection={activeSection}
                onSelectSection={setActiveSection}
                alertsExpanded={alertsExpanded}
                onToggleAlerts={() => setAlertsExpanded(prev => !prev)}
            />

            <section className={styles.content}>
                {renderContent()}
            </section>
        </div>
    );
}

export default SettingsPage;